import React, { useState, Fragment } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import { Typography, useTheme, useMediaQuery } from "@mui/material";

import FormInfo from "./FormInfo";
import { year } from "../utils/config";
import logo from "../assets/scioly_logo.png";

export default function SignPage() {
    const [submitted, setSubmitted] = useState(false);
    const [link, setLink] = useState("");

    const toggleSubmitted = () => {
        setSubmitted(!submitted);
    };

    const theme = useTheme();
    const mdOrLarger = useMediaQuery(theme.breakpoints.up("md"));
    const smOrLarger = useMediaQuery(theme.breakpoints.up("sm"));

    return (
        <Fragment>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    mt: 10,
                    mb: 3,
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        mt: 2,
                        mx: "auto",
                        width: "160px",
                        "& img": {
                            width: "100%",
                        },
                    }}
                >
                    <img src={logo} alt="MIT Science Olympiad Logo" />
                </Box>
                {mdOrLarger ? (
                    <Typography variant="h3" color="neutral.100">
                        MIT Science Olympiad {year}: Release Form
                    </Typography>
                ) : smOrLarger ? (
                    <>
                        <Typography variant="h3" color="neutral.100">
                            MIT Science Olympiad {year}:
                        </Typography>
                        <Typography variant="h3" color="neutral.100">
                            Release Form
                        </Typography>
                    </>
                ) : (
                    <Typography variant="h3" color="neutral.100">
                        Release Form
                    </Typography>
                )}
            </Box>
            <Container component="main" maxWidth="md">
                <Box mb={20}>
                    <Card>
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                mt: 3,
                                mb: 3,
                                ml: 3,
                                mr: 3,
                            }}
                        >
                            {!submitted ? (
                                <Fragment>
                                    <FormInfo
                                        submitted={submitted}
                                        setLink={setLink}
                                        toggleSubmitted={toggleSubmitted}
                                    />
                                </Fragment>
                            ) : (
                                <Fragment>
                                    <Typography variant="h6" mb={3}>
                                        Once you complete the DocuSign form, you
                                        are all set!
                                    </Typography>
                                    {/* <iframe
                                        src={link}
                                        width="100%"
                                        height="1000px"
                                    ></iframe> */}
                                    <Button
                                        variant="outlined"
                                        onClick={toggleSubmitted}
                                    >
                                        <Typography>Submit another</Typography>
                                    </Button>
                                </Fragment>
                            )}
                        </Box>
                    </Card>
                </Box>
            </Container>
        </Fragment>
    );
}
